module.exports = __webpack_public_path__ + "static/media/weight-hanging.75a97b2e.svg";